// extracted by mini-css-extract-plugin
export var compactFilters = "_fn-4";
export var detailImage = "_fn-1";
export var dropdownContainer = "_fn-2";
export var imageContainer = "_fn-0";
export var selectedCard = "_fn-3";